<template>
  <div>
    <div class="filter-label">
      Date
    </div>
    <div class="filter-options">
      <div class="range-container">
        <div class="date-container">
          <div class="date">
            <img
              src="@shared/assets/img/table/calendar-black.svg"
              class="calendar"
            >
            <span>{{ formattedDate(selectedDate.start) }}</span>
          </div>
        </div>
        <div class="line-divider" />
        <div class="date-container">
          <div class="date">
            <img
              src="@shared/assets/img/table/calendar-black.svg"
              class="calendar"
            >
            <span>{{ formattedDate(selectedDate.end) }}</span>
          </div>
          <div class="date-picker">
            <Datepicker
              v-model="dateRange"
              mode="range"
              :maxDate="today"
            />
          </div>
        </div>
      </div>
      <SACCheckbox
        label="Today"
        field="cycleType"
        :checked="existingDateFilter === 'today'"
        :change="() => handleSystemFilters(
          'dateFilter',
          'today')"
      />
      <SACCheckbox
        label="Yesterday"
        field="cycleType"
        :checked="existingDateFilter === 'yesterday'"
        :change="() => handleSystemFilters(
          'dateFilter',
          'yesterday')"
      />
      <SACCheckbox
        label="Past 3 Days"
        field="dateFilter"
        :checked="existingDateFilter === 'past3'"
        :change="() => handleSystemFilters(
          'dateFilter',
          'past3')"
      />
      <SACCheckbox
        label="Past 7 Days"
        field="dateFilter"
        :checked="existingDateFilter === 'past7'"
        :change="() => handleSystemFilters(
          'dateFilter',
          'past7')"
      />
      <SACCheckbox
        label="Past 30 days"
        field="dateFilter"
        :checked="existingDateFilter === 'past30'"
        :change="() => handleSystemFilters(
          'dateFilter',
          'past30')"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Datepicker from 'v-calendar/lib/components/date-picker.umd';
import moment from 'moment';
import SACCheckbox from '../../sac/SACCheckbox.vue';

export default {
  name: 'DateFilter',
  components: {
    SACCheckbox,
    Datepicker,
  },
  watch: {
    dateRange() {
      this.$store.dispatch('setDetailSystemFilter', {
        field: 'dateRange',
        value: this.dateRange,
      });
    },
  },
  computed: {
    ...mapState({
      existingDateFilter: state => state.customerDetail.systemFilter.dateFilter,
      selectedDate: state => state.customerDetail.systemFilter.dateRange,
    }),
  },
  data() {
    return {
      today: moment().toDate(),
      dateRange: {
        start: '',
        end: '',
      },
    };
  },
  methods: {
    handleSystemFilters(field, value, checked) {
      this.$store.dispatch('setDetailSystemFilter', {
        field,
        value,
        checked,
      });
    },
    formattedDate(d) {
      if (d) {
        return moment(d).format('M-DD-YY');
      }
      return '';
    },
  },
};
</script>

<style scoped></style>
